import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileOpen(false);
  }, [location.pathname]);

  const isActive = (path: string) => location.pathname === path;

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
            <span className="font-heading text-xl md:text-2xl font-bold text-primary-600">
              韩国漫画网
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <Link
              to="/"
              className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap ${
                isActive('/')
                  ? 'text-primary-600'
                  : 'text-foreground-700 hover:text-primary-600'
              }`}
            >
              首页
            </Link>
            <Link
              to="/category/romance"
              className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap ${
                location.pathname.startsWith('/category')
                  ? 'text-primary-600'
                  : 'text-foreground-700 hover:text-primary-600'
              }`}
            >
              分类浏览
            </Link>
            <Link
              to="/about"
              className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap ${
                isActive('/about')
                  ? 'text-primary-600'
                  : 'text-foreground-700 hover:text-primary-600'
              }`}
            >
              关于我们
            </Link>
          </div>

          <div className="hidden md:flex items-center gap-3">
            <div className="relative">
              <input
                type="text"
                placeholder="搜索漫画..."
                className="w-48 pl-9 pr-3 py-2 text-sm rounded-full bg-background-100 border border-background-200/70 text-foreground-700 placeholder-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-all duration-200"
              />
              <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-sm"></i>
            </div>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-700"
            onClick={() => setIsMobileOpen(!isMobileOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl ${isMobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {isMobileOpen && (
          <div className="md:hidden border-t border-background-200/70 py-4 flex flex-col gap-3">
            <Link
              to="/"
              className={`text-sm font-medium px-2 py-2 rounded-lg whitespace-nowrap ${
                isActive('/')
                  ? 'text-primary-600 bg-primary-50'
                  : 'text-foreground-700 hover:bg-background-100'
              }`}
            >
              首页
            </Link>
            <Link
              to="/category/romance"
              className={`text-sm font-medium px-2 py-2 rounded-lg whitespace-nowrap ${
                location.pathname.startsWith('/category')
                  ? 'text-primary-600 bg-primary-50'
                  : 'text-foreground-700 hover:bg-background-100'
              }`}
            >
              分类浏览
            </Link>
            <Link
              to="/about"
              className={`text-sm font-medium px-2 py-2 rounded-lg whitespace-nowrap ${
                isActive('/about')
                  ? 'text-primary-600 bg-primary-50'
                  : 'text-foreground-700 hover:bg-background-100'
              }`}
            >
              关于我们
            </Link>
            <div className="relative mt-2">
              <input
                type="text"
                placeholder="搜索漫画..."
                className="w-full pl-9 pr-3 py-2 text-sm rounded-full bg-background-100 border border-background-200/70 text-foreground-700 placeholder-foreground-400 focus:outline-none focus:border-primary-400 transition-all"
              />
              <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-sm"></i>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}